import type { EmailRecipient } from "@/components/crm/messages/ClientEmailSelector";
import type { Client } from "@/lib/types/database";

function normalizeComposeRecipientEmail(email: string): string {
  return email.trim().toLowerCase();
}

function findClientMatchingEmailInOptions(email: string, clientOptions: Client[]): Client | null {
  const normalized = normalizeComposeRecipientEmail(email);
  for (const client of clientOptions) {
    if (normalizeComposeRecipientEmail(client.email || "") === normalized) {
      return client;
    }
    const aliases =
      client.email_aliases?.filter((a): a is string => typeof a === "string" && a.trim() !== "") ??
      [];
    if (aliases.some((a) => normalizeComposeRecipientEmail(a) === normalized)) {
      return client;
    }
  }
  return null;
}

export function contactRowMatchesComposeRecipientEmail(
  contact: { email?: unknown; email_aliases?: unknown },
  recipientEmail: string
): boolean {
  const normalized = normalizeComposeRecipientEmail(recipientEmail);
  if (
    typeof contact.email === "string" &&
    normalizeComposeRecipientEmail(contact.email) === normalized
  ) {
    return true;
  }
  if (Array.isArray(contact.email_aliases)) {
    return contact.email_aliases.some(
      (a) => typeof a === "string" && normalizeComposeRecipientEmail(a) === normalized
    );
  }
  return false;
}

export function resolveComposeClientFromSingleToRecipient(
  recipient: EmailRecipient,
  clientOptions: Client[]
): Client | null {
  if (recipient.type === "hub_user") {
    return null;
  }
  if (recipient.type === "client") {
    if (recipient.client) {
      return recipient.client;
    }
    return clientOptions.find((c) => c.id === recipient.id) ?? null;
  }
  return findClientMatchingEmailInOptions(recipient.email, clientOptions);
}

export function composeLoneToRecipientIdentityKey(recipient: EmailRecipient): string {
  return `${recipient.type}:${recipient.id}:${normalizeComposeRecipientEmail(recipient.email)}`;
}
